module.exports = __webpack_public_path__ + "static/media/css.2998d1fc.png";